import React, { Component } from 'react'

 class Footers extends Component {
  render() {
    return (
      <div>
        
      </div>
    )
  }
}
export default Footers